module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-fixed-top navbar-default",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "header-brand navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('b', [_vm._v("Ruby")]), _vm._v(" China")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav",
    attrs: {
      "id": "nav-menu"
    }
  }, [_c('li', {
    class: {
      'active': _vm.current == 0
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/topics"
    }
  }, [_vm._v("社区")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.current == 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/wiki"
    }
  }, [_vm._v("Wiki")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.current == 2
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/sites"
    }
  }, [_vm._v("酷站")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.current == 3
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/homeland"
    }
  }, [_vm._v("Homeland")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.current == 4
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/jobs"
    }
  }, [_vm._v("招聘")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    class: {
      'active': _vm.current == 5
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/account/signin"
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.current == 6
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/account/signup"
    }
  }, [_vm._v("注册")])], 1)]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://gems.ruby-china.org",
      "target": "_blank"
    }
  }, [_vm._v("Gems")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form navbar-right"
  }, [_c('div', {
    staticClass: "header-search"
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search"
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "搜索本站内容"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-020b83d2!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Header.vue
// module id = 277
// module chunks = 6